import React from 'react'
import Report from "components/Actions/Report";

const ShopAreaReports = () => {
  return <Report />;
}

export default ShopAreaReports;
